<template>
  <div>
    <div style="padding: 20px; text-align: left;">
      <mu-row gutter>
        <mu-col span="8">
          <mu-text-field v-model.trim="verCode" full-width :placeholder="$t('Login.please_input_code')"></mu-text-field>
          <div v-if="phoneWarn" style="color: #f24; margin-top: -10px; margin-bottom: 10px;">{{ $t(warningMsg) }}</div>
        </mu-col>
        <mu-col span="4">
          <mu-button color="#777" style="width: 95%;" @click="checkVercode">{{ $t('Login.verify') }}</mu-button>
        </mu-col>
      </mu-row>
      <div>{{ $t('Login.no_received') }}
        <el-button type="primary" size="mini" @click="resendVercode" :disabled="number !== 0">{{ $t('Login.send_again') }}<span v-if="number !== 0"> {{ number }}</span></el-button>
      </div>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      verCode: '',
      phoneWarn: false,
      warningMsg: ''
    };
  },
  props: ['code', 'number'],
  methods: {
    checkVercode() {
      if (this.code === this.verCode) {
        this.phoneWarn  = false;
        this.warningMsg = '';
        this.$emit('checkFastLogin', '');
      }
      else {
        this.phoneWarn = true;
        this.warningMsg = 'Login.incorrect_code'; 
      }
    },
    resendVercode() {
      this.$emit('sendSMS', '');
      this.$emit('activeIcon', '');
    }
  },
  watch: {
    verCode(val) {
      if (val.length > 6) {
        this.verCode = this.verCode.substr(0, 6);
      }
    }
  }
}

</script>